import createReducer from 'reducers/createReducer';

import { ItemShop } from 'actions/actionTypes';

const INITIAL_STATE = {
    data: null,
    purchaseShopItem: {
        shopGuid: "",
        paymentMethodType : "CreditCard",
        itemId : "",
        quantity : 1,
    },
    error: {
        triggered: false,
        message: '',
    },
};

const reducer = createReducer(INITIAL_STATE, {
    // 내 보관함 목록
    [ItemShop.LOAD_ITEM_SHOP_LIST_REQUEST] : (state, action) => {
        state.error = INITIAL_STATE.error;
    },
    [ItemShop.LOAD_ITEM_SHOP_LIST_SUCCESS] : (state, action) => {
        state.data = action.payload;
    },
    [ItemShop.LOAD_ITEM_SHOP_LIST_FAILURE] : (state, action) => {
        state.error = {
            triggered: true,
            message: action.payload?.errorMessage,
        };
    },
})

export default reducer;